module.exports = __webpack_public_path__ + "static/media/feedback.7f0520f7.svg";